import { memo } from "react";
import { Contact } from "services/api/contacts/types";
import { TableSearch } from "ui/components/Table/TableSearch";
import { WAREHOUSE_CONTACT_LIST_COLUMNS } from "./consts";

interface WarehouseContactListProps {
    contacts: Contact[];
    onRemove: (index: number) => void;
}

const WarehouseContactList: React.FC<WarehouseContactListProps> = ({ contacts, onRemove }) => {
    if (!contacts || contacts.length === 0) return null;

    return (
        <TableSearch
            columns={WAREHOUSE_CONTACT_LIST_COLUMNS(contacts, onRemove)}
            data={contacts}
            selectableRows={false}
            disablePagination={true}
            isLoading={false}
        />
    );
};

export default memo(WarehouseContactList);
